var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmployeeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.192,
    height: 20.009,
    viewBox: "0 0 22.192 20.009",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_employee_deactive",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10643"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    d: "M16.136,592.357v-2.636a3.472,3.472,0,0,0-3.472-3.471H4.892a3.472,3.472,0,0,0-3.472,3.471v2.636",
    transform: "translate(-1.42 -574.444)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_14",
    cx: 4.027,
    cy: 4.027,
    r: 4.027,
    transform: "translate(3.331 0)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    d: "M23.58,566.05a4.027,4.027,0,0,1,0,8.054",
    transform: "translate(-10.629 -566.05)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    d: "M30.47,585.3s3.711.836,3.156,6.668",
    transform: "translate(-13.492 -574.05)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployeeIcon);
export default __webpack_public_path__ + "static/media/employee_icon.1f9bf50fe25bb5c1d06dce029da4cacd.svg";
export { ForwardRef as ReactComponent };